export default value => {
  const result = parseInt(String(value).replace(/\.(.*)/g, '').replace(/[^-\d\s]/g, ''))
  return !isNaN(result) ? result : 0
}
